import { PressNewsType } from '@/v2/types/cards'

/**
 * Public path prefix for press card images.
 * Put new files in `public/images/v2/pages/main-pages/home-page/press/`
 * and reference them as `${PRESS_IMAGE_BASE}/your-file.png`.
 */
export const PRESS_IMAGE_BASE = '/images/v2/pages/main-pages/home-page/press'

/**
 * Home-page News & Press carousel items.
 *
 * Newest first. The section is hidden when this array is empty.
 *
 * To add a story:
 * 1. Drop the image in `public/images/v2/pages/main-pages/home-page/press/`.
 * 2. Copy the example object below, increment `id`, and fill in the fields.
 *
 * @example
 * {
 *   id: 1,
 *   title: 'ShipAndStorage announces a new service.',
 *   date: 'September 20, 2026',
 *   href: 'https://www.prnewswire.com/news-releases/example.html',
 *   image: {
 *     src: `${PRESS_IMAGE_BASE}/example.png`,
 *     alt: 'ShipAndStorage announces a new service'
 *   }
 * }
 */
export const pressNews: PressNewsType[] = [
  {
    id: 1,
    title: 'ShipToBox.com Expands AI-Powered Shop & Pay Platform Ahead of Holiday 2025',
    date: 'September 3, 2026',
    href: 'https://apnews.com/press-release/ein-presswire-newsmatics/press-release-21d59d43424c5c6746f187c69b746bb9',
    image: {
      src: `${PRESS_IMAGE_BASE}/ship-to-box-com-expands-ai-powered-shop-pay-platform-ahead-of-holiday-2025.jpg`,
      alt: 'ShipToBox.com Expands AI-Powered Shop & Pay Platform Ahead of Holiday 2025'
    }
  }
]
